import type { Client } from '@openfeature/web-sdk';
import { OpenFeature } from '@openfeature/web-sdk';

/**
 * The single OpenFeature client the portal evaluates against.
 *
 * Shared deliberately: `FeatureFlagProvider` gates on this client's health and
 * `useIsFeatureFlagEnabled` reads values from it, so the fail-closed guarantee
 * only holds if both observe the *same* client. Two independent
 * `OpenFeature.getClient()` calls happen to return the same default client
 * today, but nothing enforced it — a later move to a domain-scoped client in
 * one module would silently decouple the gate from the reads.
 *
 * The global client rather than the react-sdk context client: flag-gated hooks
 * render in test trees (and error paths) with no `<OpenFeatureProvider>`
 * mounted, where the context hooks throw `MissingContextError`. The global
 * client never throws — with no provider registered it evaluates registry
 * defaults via the no-op provider.
 *
 * Kept in its own module (rather than exported from `openfeature.ts`) so the
 * read path doesn't pull the provider factory — and with it the Datadog browser
 * and flagd-web providers — into its module graph.
 */
export const flagClient: Client = OpenFeature.getClient();
